import hotkeys from 'hotkeys-js';
import _ from 'lodash';
import $ from 'jquery';
import { isMac } from '../constants';
import sleep from './sleep';

const navBarHotKeyMap = ['1', '2', '3', '4', '5', '6', '7', '8', '9'];
const patentListHotKeyMap = ['h', 'l', 'pageUp', 'pageDown', ']'];
const patentListHotKeyKeyboardValMap = {
    previous: isMac ? ['fn', '▴'] : ['Pageup'],
    next: isMac ? ['fn', '▾'] : ['Pagedown'],
    collapes: [']'],
};
const overviewMenuHotKeyMap = ['tab', 'shift + tab'];
const hotKeyTypes = ['patentList', 'navBar', 'overviewMenu'];
// 留后门，强制禁用
const isForceDisabledHotKeys = (localStorage.getItem('IS_FORCE_DISABLED_HOTKEYS') === 'true');

const patentListToggleButtonClick = (type) => {
    const element = $(`#hot-key-patents-list-${type}`)[0];
    if (element) element.click();
};

const bindPatentListHotKeys = (callback) => {
    hotkeys.unbind(patentListHotKeyMap.join(','));
    hotkeys(patentListHotKeyMap.join(','), { keyup: true }, (event, handler) => {
        event.preventDefault();
        if (event.type === 'keydown') return;

        switch (handler.key) {
            case 'h':
            case 'pageUp':
                patentListToggleButtonClick('previous');
                break;
            case 'l':
            case 'pageDown':
                patentListToggleButtonClick('next');
                break;
            case ']':
                patentListToggleButtonClick('collapes');
                break;
        }

        if (_.isFunction(callback)) callback(event, handler);
    });
};

const bindNavBarHotKeys = (callback) => {
    hotkeys.unbind(navBarHotKeyMap.join(','));
    hotkeys(navBarHotKeyMap.join(','), { keyup: true }, (event, handler) => {
        if (event.type === 'keydown') return;

        const elementList = $('#hot-key-view-root-nav .patent-app__nav-item');
        const matchElement = _.get(elementList, handler.key - 1);
        if (matchElement) {
            matchElement.click();
        }

        if (_.isFunction(callback)) callback(event, handler);
    });
};

const bindOverviewMenuHotKeys = (callback) => {
    hotkeys.unbind(overviewMenuHotKeyMap.join(','));
    hotkeys(overviewMenuHotKeyMap.join(','), { keyup: true }, async (event, handler) => {
        event.preventDefault();
        if (event.type === 'keydown') return;

        const elementList = $('#hot-key-menu-list .nav-menu__item');
        if (!elementList.length) return;

        const currentSelectedIndex = _.findIndex(elementList, ({ classList }) => _.includes(classList, 'router-link-active'));
        if (handler.key === 'tab') {
            const nextElement = elementList[currentSelectedIndex + 1];
            if (nextElement) {
                nextElement.click();
            } else {
                elementList[0].click();
            }
        } else {
            // shift和click可能会冲突 保险起见 延迟触发
            await sleep(200);
            const preElement = elementList[currentSelectedIndex - 1];
            if (preElement) {
                preElement.click();
            } else {
                elementList[elementList.length - 1].click();
            }
        }

        if (_.isFunction(callback)) callback(event, handler);
    });
};

const unBindPatentListHotKeys = () => {
    hotkeys.unbind(patentListHotKeyMap.join(','));
};

const unBindNavBarHotKeys = () => {
    hotkeys.unbind(navBarHotKeyMap.join(','));
};

const unBindOverviewMenuHotKeys = () => {
    hotkeys.unbind(overviewMenuHotKeyMap.join(','));
};

const getHotKeyMap = (type) => {
    const map = {};
    _.forEach(hotKeyTypes, key => {
        switch (key) {
            case 'patentList':
                map[key] = (type === 'bind') ? bindPatentListHotKeys : unBindPatentListHotKeys;
                break;
            case 'navBar':
                map[key] = (type === 'bind') ? bindNavBarHotKeys : unBindNavBarHotKeys;
                break;
            case 'overviewMenu':
                map[key] = (type === 'bind') ? bindOverviewMenuHotKeys : unBindOverviewMenuHotKeys;
                break;
        }
    });
    return map;
};

const bindHotKeys = (hotKeyNames, callback) => {
    if (isForceDisabledHotKeys) return;
    const bindMap = getHotKeyMap('bind');
    if (!hotKeyNames) return;
    if (_.isString(hotKeyNames) && bindMap[hotKeyNames]) {
        bindMap[hotKeyNames](callback);
    }
    if (_.isArray(hotKeyNames)) {
        _.forEach(hotKeyNames, name => {
            if (bindMap[name]) {
                bindMap[name](callback);
            }
        });
    }
};

const unBindHotKeys = (hotKeyNames) => {
    const unBindMap = getHotKeyMap('unBind');
    if (!hotKeyNames) return;
    if (_.isString(hotKeyNames) && unBindMap[hotKeyNames]) {
        unBindMap[hotKeyNames]();
    }
    if (_.isArray(hotKeyNames)) {
        _.forEach(hotKeyNames, name => {
            if (unBindMap[name]) {
                unBindMap[name]();
            }
        });
    }
};

export {
    patentListHotKeyKeyboardValMap,
    bindHotKeys,
    unBindHotKeys,
};
